//code.js

import {
  defineStore
} from "pinia";
import {
  ref,
  reactive,
  inject,
  onMounted,
  onBeforeUpdate
} from "vue";
import {
  sessionUserInfo,
  load
} from "@/common/sessionFactory";
import util from "@/common/util";
import axios from "@/axios/index";


//휴대폰 인증 통신사
export const getPhoneTypCd = [
  {code:"1", name:"SKT"},
  {code:"2", name:"KT"},
  {code:"3", name:"LG U+"},
  {code:"5", name:"SKT 알뜰폰"},
  {code:"6", name:"KT 알뜰폰"},
  {code:"7", name:"LG U+ 알뜰폰"}
]

//관리자 회원 정보 수정 사업자 구분
export const getIndCorpTypCd = [{
  code: "C",
  name: "법인사업자"
},
{
  code: "P",
  name: "개인사업자"
},
{
  code: "S",
  name: "서베이"
},
{
  code: "A",
  name: "관리자"
},
]

//관리자 회원 정보 수정 인수형태
export const getPolhdGb = [{
  code: "1",
  name: "당사 단독"
},
{
  code: "2",
  name: "당사 간사"
},

]

//관리자 회원 정보 수정 협정비협정구분
export const getAgrmNList = [{
  code: "1",
  name: "협정"
},
{
  code: "2",
  name: "비협정"
},

]

//청약 입력 조회 구분
export const getSeachStockBunho = [{
    code: "1",
    name: "가청약번호"
  },
  {
    code: "2",
    name: "진계약번호 / 참조번호"
  },

]

//청약 입력/조회 및 증권 출력 조회 조건
export const getSeachType = [{
    code: "1",
    name: "기간"
  },
  {
    code: "2",
    name: "증권"
  },
  {
    code: "3",
    name: "Ref NO."
  },
]

//통계 보험 종목
export const getIprodType = [{
    code: "",
    name: "전체"
  },
  {
    code: "21010",
    name: "수출"
  },
  {
    code: "21000",
    name: "수입"
  },
]

//질권은행 리스트
export const getBankCodeList = [
  {
    code: "",
    name: ""
  },
  {
    code: "28dxeuWSmT",
    name: "한국산업은행"
  },
  {
    code: "28dxeuWUPP",
    name: "(주)한국씨티은행"
  },
  {
    code: "28dxeuWUT0",
    name: "(주)한국스탠다드차타드은행"
  },
  {
    code: "28dxeuWVjm",
    name: "(주)신한은행"
  },
  {
    code: "28dxeuWWqf",
    name: "한국은행"
  },
  {
    code: "28dxeuWXjM",
    name: "농협은행(주)"
  },
  {
    code: "28dxeub9Y5",
    name: "(주)우리은행"
  },
  {
    code: "28dxeubAFJ",
    name: "(주)국민은행"
  },
  {
    code: "28dxeubBSz",
    name: "중소기업은행"
  },
  {
    code: "28dxeubBVf",
    name: "(주)한국외환은행"
  },
  {
    code: "28dxeubBl8",
    name: "(주)하나은행"
  },
  {
    code: "28dxeubxWd",
    name: "수산업협동조합중앙회"
  },
  {
    code: "28dxeugSb2",
    name: "(주)광주은행"
  },
  {
    code: "28dxeuoH9r",
    name: "(주)대구은행"
  },
  {
    code: "28dxev612h",
    name: "(주)부산은행"
  },
  {
    code: "28dxev6At6",
    name: "(주)경남은행"
  },
];

//환종코드
export const getCurCodeList = [{
    code: "KRW",
    name: "한국"
  },
  {
    code: "USD",
    name: "미국"
  },
  {
    code: "EUR",
    name: "유로"
  },
  {
    code: "JPY",
    name: "일본"
  },
  {
    code: "ATS",
    name: "오스트리아"
  },
  {
    code: "AUD",
    name: "호주"
  },
  {
    code: "BHD",
    name: "바레인"
  },
  {
    code: "BEF",
    name: "벨기에"
  },
  {
    code: "THB",
    name: "태국"
  },
  {
    code: "CAD",
    name: "카나다"
  },
  {
    code: "DKK",
    name: "덴마크"
  },
  {
    code: "DEM",
    name: "독일"
  },
  {
    code: "FRF",
    name: "프랑스"
  },
  {
    code: "FIM",
    name: "핀란드"
  },
  {
    code: "NLG",
    name: "네덜란드"
  },
  {
    code: "HKD",
    name: "홍콩"
  },
  {
    code: "INR",
    name: "인도"
  },
  {
    code: "IDR",
    name: "인도네시아"
  },
  {
    code: "KWD",
    name: "쿠웨이트"
  },
  {
    code: "ITL",
    name: "이탈리아"
  },
  {
    code: "MYR",
    name: "말레이시아"
  },
  {
    code: "NOK",
    name: "노르웨이"
  },
  {
    code: "NZD",
    name: "뉴질랜드"
  },
  {
    code: "ESP",
    name: "스페인"
  },
  {
    code: "CNY",
    name: "중국"
  },
  {
    code: "SAR",
    name: "사우디"
  },
  {
    code: "CHF",
    name: "스위스"
  },
  {
    code: "SGD",
    name: "싱가포르"
  },
  {
    code: "SEK",
    name: "스웨덴"
  },
  {
    code: "AED",
    name: "UAE"
  },
  {
    code: "GBP",
    name: "영국"
  },
];

//원본부수
export const getOrigCntCodeList = [{
    code: "1",
    name: "1매"
  },
  {
    code: "2",
    name: "2매"
  },
  {
    code: "3",
    name: "3매"
  },
  {
    code: "4",
    name: "4매"
  },
  {
    code: "5",
    name: "5매"
  },
];

//포장형태
export const getPackageTypeList = [{
    code: "01",
    name: "BAG"
  },
  {
    code: "02",
    name: "BOTTLE"
  },
  {
    code: "03",
    name: "BULK"
  },
  {
    code: "04",
    name: "CASE"
  },
  {
    code: "05",
    name: "CONTAINER"
  },
  {
    code: "06",
    name: "DRUM/CAN"
  },
  {
    code: "07",
    name: "PALLETE"
  },
  {
    code: "08",
    name: "CARTON BOX"
  },
  {
    code: "99",
    name: "OTHERS"
  },
];

//참조번호
export const getRefNo1List = [{
    code: "",
    name: "선택"
  },
  {
    code: "01",
    name: "P/I NO."
  },
  {
    code: "02",
    name: "P/O NO."
  },
  {
    code: "03",
    name: "D/A NO."
  },
  {
    code: "04",
    name: "D/P NO."
  },
  {
    code: "05",
    name: "FILE NO."
  },
  {
    code: "06",
    name: "L/C NO."
  },
  {
    code: "07",
    name: "INVOICE NO."
  },
  {
    code: "08",
    name: "OFFER NO."
  },
  {
    code: "09",
    name: "ORDER NO."
  },
  {
    code: "10",
    name: "I/L NO."
  },
  {
    code: "11",
    name: "B/L NO."
  },
  {
    code: "12",
    name: "SALES OF CONTRACT NO."
  },
  {
    code: "13",
    name: "CONTRACT NO."
  },
  {
    code: "15",
    name: "SALES NOTE NO."
  },
  {
    code: "14",
    name: "OTHERS"
  },
];

//도시코드 대코드
export const getLrgMenuCityCode = [{
    code: "A",
    name: "A"
  },
  {
    code: "B",
    name: "B"
  },
  {
    code: "C",
    name: "C"
  },
  {
    code: "D",
    name: "D"
  },
  {
    code: "E",
    name: "E"
  },
  {
    code: "F",
    name: "F"
  },
  {
    code: "G",
    name: "G"
  },
  {
    code: "H",
    name: "H"
  },
  {
    code: "I",
    name: "I"
  },
  {
    code: "J",
    name: "J"
  },
  {
    code: "K",
    name: "K"
  },
  {
    code: "L",
    name: "L"
  },
  {
    code: "M",
    name: "M"
  },
  {
    code: "N",
    name: "N"
  },
  {
    code: "O",
    name: "O"
  },
  {
    code: "P",
    name: "P"
  },
  {
    code: "Q",
    name: "Q"
  },
  {
    code: "R",
    name: "R"
  },
  {
    code: "S",
    name: "S"
  },
  {
    code: "T",
    name: "T"
  },
  {
    code: "U",
    name: "U"
  },
  {
    code: "V",
    name: "V"
  },
  {
    code: "W",
    name: "W"
  },
  {
    code: "X",
    name: "X"
  },
  {
    code: "Y",
    name: "Y"
  },
  {
    code: "Z",
    name: "Z"
  },
];

//증권 출력 원본
export const getPolCntCodeList = [{
    code: "0",
    name: "0매"
  },
  {
    code: "1",
    name: "1매"
  },
  {
    code: "2",
    name: "2매"
  },
  {
    code: "3",
    name: "3매"
  },
  {
    code: "4",
    name: "4매"
  },
];

//배서 출력 원본
export const getEndrCntCodeList = [{
    code: "0",
    name: "0매"
  },
  {
    code: "1",
    name: "1매"
  },
  {
    code: "2",
    name: "2매"
  },
  {
    code: "3",
    name: "3매"
  },
  {
    code: "4",
    name: "4매"
  },
];

//INVOICE
export const getInvoiceCntCodeList = [{
    code: "0",
    name: "0매"
  },
  {
    code: "1",
    name: "1매"
  },
  {
    code: "2",
    name: "2매"
  },
  {
    code: "3",
    name: "3매"
  },
  {
    code: "4",
    name: "4매"
  },
];

//INVOICE 27000
export const getInvoiceCntCodeList2 = [{
  code: "0",
  name: "0매"
},
{
  code: "1",
  name: "1매"
},
];

//복사여부
export const getCopyCntCodeList = [{
    code: "0",
    name: "0매"
  },
  {
    code: "1",
    name: "1매"
  },
  {
    code: "2",
    name: "2매"
  },
  {
    code: "3",
    name: "3매"
  },
  {
    code: "4",
    name: "4매"
  },
  {
    code: "5",
    name: "5매"
  },
  {
    code: "6",
    name: "6매"
  },
  {
    code: "7",
    name: "7매"
  },
  {
    code: "8",
    name: "8매"
  },
  {
    code: "9",
    name: "9매"
  },
];

export const getHcCodeGubunList = [{
    code: "0",
    name: "HS코드"
  },
  {
    code: "1",
    name: "HS코드명"
  },
];

//팀 분류 코드
export const useTeamCodeStore = defineStore("teamCode", () => {
  let teamCode = null;

  async function getTeamCodeList() {
    await load();

    if (_.isEmpty(teamCode)) {
      const param = {
        cusNo: "122202653",
      };
      let result = await axios.transaction("FNGCTGFO0047", param);
      teamCode = result;
    }
    return teamCode;
  }
  return {
    getTeamCodeList
  };
});

//운송수단
export const getTrsMethCodeList = [{
    code: "01",
    name: "선박"
  },
  {
    code: "02",
    name: "항공"
  },
];

//부가조건
export const getAddCondList = [{
    code: "",
    name: ""
  },
  {
    code: "21112A|2|1|BULK OIL CL. IN EXCESS OF 0.5%|EXCESS|0.5",
    name: "BULK OIL CL. IN EXCESS OF 0.5%",
  },
  {
    code: "21112A|2|1|BULK OIL CL. IN EXCESS OF 1%|EXCESS|1",
    name: "BULK OIL CL. IN EXCESS OF 1%",
  },
  {
    code: "21112A|2|1|BULK OIL CL. IN EXCESS OF 2%|EXCESS|2",
    name: "BULK OIL CL. IN EXCESS OF 2%",
  },
  {
    code: "21112A|2|1|BULK OIL CL. IN EXCESS OF 3%|EXCESS|3",
    name: "BULK OIL CL. IN EXCESS OF 3%",
  },
  {
    code: "21112A|2|1|BULK OIL CL. IN EXCESS OF 4%|EXCESS|4",
    name: "BULK OIL CL. IN EXCESS OF 4%",
  },
  {
    code: "21112A|2|1|BULK OIL CL. IN EXCESS OF 5%|EXCESS|5",
    name: "BULK OIL CL. IN EXCESS OF 5%",
  },
  {
    code: "21113A|2|1|I.F.F.C. (A/R)||",
    name: "I.F.F.C. (A/R)"
  },
  {
    code: "21114A|2|1|I.F.F.C. (A)||",
    name: "I.F.F.C. (A)"
  },
  {
    code: "21124A|2|1|HEATING & SPONTANOUS||",
    name: "HEATING & SPONTANOUS"
  },
  {
    code: "21162A|2|1|INSITUTE CARGO CLAUSE(A)||",
    name: "INSITUTE CARGO CLAUSE(A)",
  },
  {
    code: "21201A|2|1|BREAKAGE||",
    name: "BREAKAGE"
  },
  {
    code: "21202A|2|1|BREAKAGE IN EXCESS OF 0.5%|EXCESS|0.5",
    name: "BREAKAGE IN EXCESS OF 0.5%",
  },
  {
    code: "21202A|2|1|BREAKAGE IN EXCESS OF 1%|EXCESS|1",
    name: "BREAKAGE IN EXCESS OF 1%",
  },
  {
    code: "21202A|2|1|BREAKAGE IN EXCESS OF 2%|EXCESS|2",
    name: "BREAKAGE IN EXCESS OF 2%",
  },
  {
    code: "21202A|2|1|BREAKAGE IN EXCESS OF 3%|EXCESS|3",
    name: "BREAKAGE IN EXCESS OF 3%",
  },
  {
    code: "21202A|2|1|BREAKAGE IN EXCESS OF 4%|EXCESS|4",
    name: "BREAKAGE IN EXCESS OF 4%",
  },
  {
    code: "21202A|2|1|BREAKAGE IN EXCESS OF 5%|EXCESS|5",
    name: "BREAKAGE IN EXCESS OF 5%",
  },
  {
    code: "21206A|2|1|CONTAMINATION||",
    name: "CONTAMINATION"
  },
  {
    code: "21207A|2|1|COUNTRY DAMAGE||",
    name: "COUNTRY DAMAGE"
  },
  {
    code: "21208A|2|1|CUSTOM DUTY CLAUSE||",
    name: "CUSTOM DUTY CLAUSE"
  },
  {
    code: "21208B|2|1|TPND (T/L OF EACH PACKAGE)||",
    name: "TPND (T/L OF EACH PACKAGE)",
  },
  {
    code: "21209A|2|1|DENTING AND BENDING||",
    name: "DENTING AND BENDING"
  },
  {
    code: "21210A|2|1|EXPLOSION||",
    name: "EXPLOSION"
  },
  {
    code: "21210B|2|1|DISCHARGING RISK||",
    name: "DISCHARGING RISK"
  },
  {
    code: "21211A|2|1|EXCL. BREAKAGE||",
    name: "EXCL. BREAKAGE"
  },
  {
    code: "21211B|2|1|DRYING CHARGE CL.||",
    name: "DRYING CHARGE CL."
  },
  {
    code: "21213A|2|1|EXCL. MORTALITY||",
    name: "EXCL. MORTALITY"
  },
  {
    code: "21214B|2|1|OPEN YARD STORAGE CLAUSE||",
    name: "OPEN YARD STORAGE CLAUSE",
  },

  {
    code: "21215A|2|1|EXCL. SHORTAGE DUE TO BREAKAGE||",
    name: "EXCL. SHORTAGE DUE TO BREAKAGE",
  },
  {
    code: "21216A|2|1|EXCL. SHORTAGE||",
    name: "EXCL. SHORTAGE"
  },
  {
    code: "21217A|2|1|EXCL. SWEAT & HEATING||",
    name: "EXCL. SWEAT & HEATING"
  },

  {
    code: "21222A|2|1|ISE|일수|",
    name: "ISE"
  },
  {
    code: "21222A|2|1|ISE|일수|30",
    name: "ISE 30 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|60",
    name: "ISE 60 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|90",
    name: "ISE 90 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|100",
    name: "ISE 100 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|105",
    name: "ISE 105 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|110",
    name: "ISE 110 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|120",
    name: "ISE 120 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|130",
    name: "ISE 130 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|140",
    name: "ISE 140 DAYS"
  },
  {
    code: "21222A|2|1|ISE|일수|150",
    name: "ISE 150 DAYS"
  },

  {
    code: "21224A|2|1|ISE 30 DAYS||",
    name: "ISE 30 DAYS"
  },
  {
    code: "21225A|2|1|ISE 60 DAYS||",
    name: "ISE 60 DAYS"
  },
  {
    code: "21226A|2|1|ISE 90 DAYS||",
    name: "ISE 90 DAYS"
  },
  {
    code: "21227A|2|1|ISE 100 DAYS||",
    name: "ISE 100 DAYS"
  },
  {
    code: "21201B|2|1|ISE 105 DAYS||",
    name: "ISE 105 DAYS"
  },
  {
    code: "21228A|2|1|ISE 110 DAYS||",
    name: "ISE 110 DAYS"
  },
  {
    code: "21229A|2|1|ISE 120 DAYS||",
    name: "ISE 120 DAYS"
  },
  {
    code: "21230A|2|1|ISE 130 DAYS||",
    name: "ISE 130 DAYS"
  },
  {
    code: "21231A|2|1|ISE 140 DAYS||",
    name: "ISE 140 DAYS"
  },
  {
    code: "21232A|2|1|ISE 150 DAYS||",
    name: "ISE 150 DAYS"
  },

  {
    code: "21233A|2|1|JETTISON AND/OR WASHING OVERBOARD||",
    name: "JETTISON AND/OR WASHING OVERBOARD",
  },
  {
    code: "21235A|2|1|LABEL CLAUSES||",
    name: "LABEL CLAUSES"
  },
  {
    code: "21237A|2|1|LIVE - FISH CLAUSES(A)||",
    name: "LIVE - FISH CLAUSES(A)",
  },
  {
    code: "21238A|2|1|LIVE - FISH CLAUSES(B)||",
    name: "LIVE - FISH CLAUSES(B)",
  },
  {
    code: "21239A|2|1|LIVESTOCK CLAUSES(A)||",
    name: "LIVESTOCK CLAUSES(A)"
  },
  {
    code: "21240A|2|1|LIVESTOCK CLAUSES(B)||",
    name: "LIVESTOCK CLAUSES(B)"
  },
  {
    code: "21242A|2|1|ON DECK||",
    name: "ON DECK"
  },

  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A)||",
    name: "PIPE LINE CLAUSE(A)"
  },
  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A) IN EXCESS OF 0.5%|EXCESS|0.5",
    name: "PIPE LINE CLAUSE(A) IN EXCESS OF 0.5%",
  },
  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A) IN EXCESS OF 1%|EXCESS|1",
    name: "PIPE LINE CLAUSE(A) IN EXCESS OF 1%",
  },
  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A) IN EXCESS OF 2%|EXCESS|2",
    name: "PIPE LINE CLAUSE(A) IN EXCESS OF 2%",
  },
  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A) IN EXCESS OF 3%|EXCESS|3",
    name: "PIPE LINE CLAUSE(A) IN EXCESS OF 3%",
  },
  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A) IN EXCESS OF 4%|EXCESS|4",
    name: "PIPE LINE CLAUSE(A) IN EXCESS OF 4%",
  },
  {
    code: "21243A|2|1|PIPE LINE CLAUSE(A) IN EXCESS OF 5%|EXCESS|5",
    name: "PIPE LINE CLAUSE(A) IN EXCESS OF 5%",
  },

  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B)||",
    name: "PIPE LINE CLAUSE(B)"
  },
  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B) IN EXCESS OF 0.5%|EXCESS|0.5",
    name: "PIPE LINE CLAUSE(B) IN EXCESS OF 0.5%",
  },
  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B) IN EXCESS OF 1%|EXCESS|1",
    name: "PIPE LINE CLAUSE(B) IN EXCESS OF 1%",
  },
  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B) IN EXCESS OF 2%|EXCESS|2",
    name: "PIPE LINE CLAUSE(B) IN EXCESS OF 2%",
  },
  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B) IN EXCESS OF 3%|EXCESS|3",
    name: "PIPE LINE CLAUSE(B) IN EXCESS OF 3%",
  },
  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B) IN EXCESS OF 4%|EXCESS|4",
    name: "PIPE LINE CLAUSE(B) IN EXCESS OF 4%",
  },
  {
    code: "21244A|2|1|PIPE LINE CLAUSE(B) IN EXCESS OF 5%|EXCESS|5",
    name: "PIPE LINE CLAUSE(B) IN EXCESS OF 5%",
  },

  {
    code: "21249A|2|1|RAIN AND/OR FRESH WATER DAMAGE||",
    name: "RAIN AND/OR FRESH WATER DAMAGE",
  },

  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION IN EXCESS OF 0.5%|EXCESS|0.5",
    name: "RUST OXIDATION & DISCOLORATION IN EXCESS OF 0.5%",
  },
  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION IN EXCESS OF 1%|EXCESS|1",
    name: "RUST OXIDATION & DISCOLORATION IN EXCESS OF 1%",
  },
  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION IN EXCESS OF 2%|EXCESS|2",
    name: "RUST OXIDATION & DISCOLORATION IN EXCESS OF 2%",
  },
  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION IN EXCESS OF 3%|EXCESS|3",
    name: "RUST OXIDATION & DISCOLORATION IN EXCESS OF 3%",
  },
  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION IN EXCESS OF 4%|EXCESS|4",
    name: "RUST OXIDATION & DISCOLORATION IN EXCESS OF 4%",
  },
  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION IN EXCESS OF 5%|EXCESS|5",
    name: "RUST OXIDATION & DISCOLORATION IN EXCESS OF 5%",
  },

  {
    code: "21252A|2|1|RUST OXIDATION & DISCOLORATION||",
    name: "RUST OXIDATION & DISCOLORATION",
  },
  {
    code: "21253A|2|1|REFRIGERATED CARGO CLAUSE||",
    name: "REFRIGERATED CARGO CLAUSE",
  },
  {
    code: "21254A|2|1|REFRIGERATING MACHINERY CLAUSE||",
    name: "REFRIGERATING MACHINERY CLAUSE",
  },
  {
    code: "21255A|2|1|REJECTION CLAUSE||",
    name: "REJECTION CLAUSE"
  },
  {
    code: "21256A|2|1|REP. CLAUSE(SECONDHAND)||",
    name: "REP. CLAUSE(SECONDHAND)",
  },
  {
    code: "21259A|2|1|SWEAT AND HEATING||",
    name: "SWEAT AND HEATING"
  },

  {
    code: "21260A|2|1|SHORTAGE||",
    name: "SHORTAGE"
  },
  {
    code: "21261A|2|1|SHORTAGE IN EXCESS OF 0.5%|EXCESS|0.5",
    name: "SHORTAGE IN EXCESS OF 0.5%",
  },
  {
    code: "21261A|2|1|SHORTAGE IN EXCESS OF 1%|EXCESS|1",
    name: "SHORTAGE IN EXCESS OF 1%",
  },
  {
    code: "21261A|2|1|SHORTAGE IN EXCESS OF 2%|EXCESS|2",
    name: "SHORTAGE IN EXCESS OF 2%",
  },
  {
    code: "21261A|2|1|SHORTAGE IN EXCESS OF 3%|EXCESS|3",
    name: "SHORTAGE IN EXCESS OF 3%",
  },
  {
    code: "21261A|2|1|SHORTAGE IN EXCESS OF 4%|EXCESS|4",
    name: "SHORTAGE IN EXCESS OF 4%",
  },
  {
    code: "21261A|2|1|SHORTAGE IN EXCESS OF 5%|EXCESS|5",
    name: "SHORTAGE IN EXCESS OF 5%",
  },

  {
    code: "21262A|2|1|SHORTAGE DUE TO COVERTORN||",
    name: "SHORTAGE DUE TO COVERTORN",
  },
  {
    code: "21262A|2|1|SHORTAGE IN EXCESS OF 0.5% DUE TO COVERTORN|EXCESS|0.5",
    name: "SHORTAGE IN EXCESS OF 0.5% DUE TO COVERTORN",
  },
  {
    code: "21262A|2|1|SHORTAGE IN EXCESS OF 1% DUE TO COVERTORN|EXCESS|1",
    name: "SHORTAGE IN EXCESS OF 1% DUE TO COVERTORN",
  },
  {
    code: "21262A|2|1|SHORTAGE IN EXCESS OF 2% DUE TO COVERTORN|EXCESS|2",
    name: "SHORTAGE IN EXCESS OF 2% DUE TO COVERTORN",
  },
  {
    code: "21262A|2|1|SHORTAGE IN EXCESS OF 3% DUE TO COVERTORN|EXCESS|3",
    name: "SHORTAGE IN EXCESS OF 3% DUE TO COVERTORN",
  },
  {
    code: "21262A|2|1|SHORTAGE IN EXCESS OF 4% DUE TO COVERTORN|EXCESS|4",
    name: "SHORTAGE IN EXCESS OF 4% DUE TO COVERTORN",
  },
  {
    code: "21262A|2|1|SHORTAGE IN EXCESS OF 5% DUE TO COVERTORN|EXCESS|5",
    name: "SHORTAGE IN EXCESS OF 5% DUE TO COVERTORN",
  },

  {
    code: "21263A|2|1|SHORTAGE IN EXCESS OF 0.5% DUE TO BREAKAGE|EXCESS|0.5",
    name: "SHORTAGE IN EXCESS OF 0.5% DUE TO BREAKAGE",
  },
  {
    code: "21263A|2|1|SHORTAGE IN EXCESS OF 1% DUE TO BREAKAGE|EXCESS|1",
    name: "SHORTAGE IN EXCESS OF 1% DUE TO BREAKAGE",
  },
  {
    code: "21263A|2|1|SHORTAGE IN EXCESS OF 2% DUE TO BREAKAGE|EXCESS|2",
    name: "SHORTAGE IN EXCESS OF 2% DUE TO BREAKAGE",
  },
  {
    code: "21263A|2|1|SHORTAGE IN EXCESS OF 3% DUE TO BREAKAGE|EXCESS|3",
    name: "SHORTAGE IN EXCESS OF 3% DUE TO BREAKAGE",
  },
  {
    code: "21263A|2|1|SHORTAGE IN EXCESS OF 4% DUE TO BREAKAGE|EXCESS|4",
    name: "SHORTAGE IN EXCESS OF 4% DUE TO BREAKAGE",
  },
  {
    code: "21263A|2|1|SHORTAGE IN EXCESS OF 5% DUE TO BREAKAGE|EXCESS|5",
    name: "SHORTAGE IN EXCESS OF 5% DUE TO BREAKAGE",
  },

  {
    code: "21268A|2|1|SPECIAL REPLACEMENT CL.(NEW)||",
    name: "SPECIAL REPLACEMENT CL.(NEW)",
  },
  {
    code: "21269A|2|1|SPECIAL SURVEY CLAUSE||",
    name: "SPECIAL SURVEY CLAUSE"
  },
  {
    code: "21270A|2|2|STRIKES(AIR)||",
    name: "STRIKES(AIR)"
  },
  {
    code: "21271A|2|1|STRIKES(CARGO)||",
    name: "STRIKES(CARGO)"
  },
  {
    code: "21272A|2|1|S.R.C.C.||",
    name: "S.R.C.C."
  },
  {
    code: "21273A|2|1|SHORTAGE DRUM OR CAN||",
    name: "SHORTAGE DRUM OR CAN"
  },
  {
    code: "21274A|2|1|TPND||",
    name: "TPND"
  },
  {
    code: "21276A|2|1|WAIVER OF SUBROGATION||",
    name: "WAIVER OF SUBROGATION"
  },
  {
    code: "21277A|2|2|WAR(AIR)||",
    name: "WAR(AIR)"
  },
  {
    code: "21278A|2|1|WAR(CARGO)||",
    name: "WAR(CARGO)"
  },
  {
    code: "21282A|2|1|WAR/S.R.C.C||",
    name: "WAR/S.R.C.C"
  },
  {
    code: "21283A|2|1|WAR/STRIKE(CARGO)||",
    name: "WAR/STRIKE(CARGO)"
  },
  {
    code: "21284A|2|2|WAR(AIR)/S.R.C.C||",
    name: "WAR(AIR)/S.R.C.C"
  },
  {
    code: "21285A|2|2|WAR(AIR)/STRIKE(AIR)||",
    name: "WAR(AIR)/STRIKE(AIR)"
  },
  {
    code: "21295A|2|2|SUBJECT TO NOT BULK||",
    name: "SUBJECT TO NOT BULK"
  },
];

//수입상품코드
export const getIncmProdList = [{
    code: "21000|2100A",
    name: "적하수입보험, 적하보험표준약관",
  },
  {
    code: "21000|2100B",
    name: "적하수입보험, Stock Throughput Insurance (I)",
  },
  {
    code: "21000|2100C",
    name: "적하수입보험, Stock Throughput Insurance (II)",
  },
  {
    code: "21000|2100D",
    name: "적하수입보험, Stock Throughput Insurance (III)",
  },
  {
    code: "21000|2100E",
    name: "적하수입보험, Stock Throughput Insurance (IV)",
  },
  {
    code: "21000|2100F",
    name: "적하수입보험, Stock Throughput Insurance (Ⅴ)",
  },
  {
    code: "21000|2100J",
    name: "적하수입보험, Stock Throughput Insurance Policy(VI)",
  },
  {
    code: "21000|2100G",
    name: "적하수입보험, Marine Cargo & Marine Consequential Loss Insurance",
  },
  {
    code: "21000|2100H",
    name: "적하수입보험, 항공화물화주보험",
  },
  {
    code: "21000|2100I",
    name: "적하수입보험, 적하수입보험_수재",
  },
  {
    code: "2R010|2R01A",
    name: "적하수입보험(리젠트), 적하수입보험(리젠트)",
  },
];

//수출 상품코드
export const getExptProdList = [{
    code: "21010|2101A",
    name: "적하수출보험, 적하보험표준약관"
  },
  {
    code: "21010|2101B",
    name: "적하수출보험, Stock Throughput Insurance (I)"
  },
  {
    code: "21010|2101C",
    name: "적하수출보험, Stock Throughput Insurance (II)",
  },
  {
    code: "21010|2101D",
    name: "적하수출보험, Stock Throughput Insurance (III)",
  },
  {
    code: "21010|2101E",
    name: "적하수출보험, Stock Throughput Insurance (IV)",
  },
  {
    code: "21010|2101E",
    name: "적하수출보험, Stock Throughput Insurance (IV)",
  },
  {
    code: "21010|2101F",
    name: "적하수출보험, 적하수출보험, Stock Throughput Insurance (Ⅴ)",
  },
  {
    code: "21010|2101J",
    name: "적하수출보험, Stock Throughput Insurance Policy(VI)",
  },
  {
    code: "21010|2101G",
    name: "적하수출보험, Marine Cargo & Marine Consequential Loss Insurance",
  },
  {
    code: "21010|2101H",
    name: "적하수출보험, 항공화물화주보험",
  },
  {
    code: "21010|2101I",
    name: "적하수출보험, 적하수출보험_수재",
  },
  {
    code: "2R020|2R02A",
    name: "적하수출보험(리젠트), 적하수출보험(리젠트)",
  },
];

//보험 조건
export const getInsCondList = [{
    code: "21101A|1|1|I.C.C.(A) (신약관전위험담보)||",
    name: "I.C.C.(A) (신약관전위험담보)",
  },
  {
    code: "21102A|1|1|I.C.C.(B) (신약관분손담보)||",
    name: "I.C.C.(B) (신약관분손담보)",
  },
  {
    code: "21103A|1|1|I.C.C.(C) (신약관분손부담보)||",
    name: "I.C.C.(C) (신약관분손부담보) ",
  },
  {
    code: "21104A|1|2|I.C.C.(AIR) (신약관항공운송용)||",
    name: "I.C.C.(AIR) (신약관항공운송용)",
  },
  {
    code: "21105A|1|1|ALL RISK (구약관전위험담보)||",
    name: "ALL RISK (구약관전위험담보)",
  },
  {
    code: "21106A|1|1|W.A.I.O.P (구약관분손담보)||",
    name: "W.A.I.O.P (구약관분손담보)",
  },
  {
    code: "21107A|1|1|W.A.3% (구약관분손담보 3%미만손해 부담보)||",
    name: "W.A.3% (구약관분손담보 3%미만손해 부담보)",
  },
  {
    code: "21108A|1|1|F.P.A (구약관분손부담보)||",
    name: "F.P.A (구약관분손부담보)",
  },
  {
    code: "21109A|1|2|ALL RISKS (AIR) (구약관항공운송용)||",
    name: "ALL RISKS (AIR) (구약관항공운송용)",
  },
];